import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import useAuth from '@/auth/useAuth';
import { routeLogin } from '@/auth/constants/authSettings';

function LogoutPage() {
	const { signOut } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		signOut();
		navigate(routeLogin, { replace: true });
	}, [navigate, signOut]);

	return null;
}

export default LogoutPage;
